// extracted by mini-css-extract-plugin
export default {"submitButton":"Auth_submitButton__OsqY8","marginLeft5":"Auth_marginLeft5__ZROjl"};